<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-02-22 14:37:43
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-01-06 10:13:53
-->
<template>
	<el-dialog title="提示" width="25%" :visible.sync="visible" :before-close="handClose">
		<p
			><i class="el-icon-warning warning mr-6"></i><span v-if="isExportImg">本次导出将导出查询结果的全部数据。</span
			><span>5分钟内仅可导出一次，导出后可在导出记录中查看导出进度，导出成功的数据请在24小时内下载。</span></p
		>
		<div class="mt-16 ml-16" v-if="isExportImg"> <el-checkbox v-model="checked">导出时同步导出图片</el-checkbox> </div>
		<div class="mt-16 ml-16 flex-row-align-center" v-if="isExportSku">
			<el-radio v-model="option" :label="0"
				>按商品导出<Explain content="按商品维度导出，每个商品ID为1条数据" inline icon="icon-a-help-circlebangzhu-mian"> </Explain
			></el-radio>
			<el-radio v-model="option" :label="1"
				>按商品规格导出<Explain content="按商品规格拆分导出，同商品多规格会展示多条数据" inline icon="icon-a-help-circlebangzhu-mian"> </Explain
			></el-radio>
		</div>
		<div class="footer-dialog" slot="footer">
			<el-button @click="handClose">取 消</el-button>
			<el-button type="primary" @click="exportFun">导 出</el-button>
		</div>
	</el-dialog>
</template>
<script>
import Explain from '@/components/common/explain';
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: '',
		},
		//是否支持导出图片
		isExportImg: {
			type: Boolean,
			default: false,
		},
		isExportSku: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		Explain,
	},
	data() {
		return {
			visible: false,
			exportDialog: () => {},
			checked: false,
			option: 0,
		};
	},
	methods: {
		show(exportDialog) {
			this.exportDialog = exportDialog;
			this.visible = true;
		},
		async exportFun() {
			this.exportDialog(this.checked, this.option);
		},
		handClose() {
			this.visible = false;
			this.checked = false;
			this.option = 0;
		},
	},
};
</script>
<style lang="less" scoped>
.warning {
	color: #fa8f14;
}
</style>
